import type { Folder } from "certiblok-api-manager";
import { atom } from "jotai";

export const availableUploadDocumentSteps = ["chooseFolder", "uploadDocuments", "recap"] as const;

export const uploadDocumentStepAtom = atom<(typeof availableUploadDocumentSteps)[number]>("chooseFolder");
export const selectedFolderAtom = atom<string | undefined>(undefined);
export const selectedFolderHistoryAtom = atom<Folder[]>([]);
